import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
const defaultOptions = {} as const;

export type NotificationsMarkAsReadMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.MarkAsReadInput;
}>;

export type NotificationsMarkAsReadMutationResult = { __typename?: 'Mutation' } & {
  notificationsMarkAsRead?: GraphQLTypes.Maybe<
    { __typename?: 'MarkAsReadPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message'>>>;
    }
  >;
};

export const NotificationsMarkAsReadDocument = /*#__PURE__*/ gql`
  mutation notificationsMarkAsRead($input: MarkAsReadInput!) {
    notificationsMarkAsRead(input: $input) {
      errors {
        message
      }
    }
  }
`;

/**
 * __useNotificationsMarkAsReadMutation__
 *
 * To run a mutation, you first call `useNotificationsMarkAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationsMarkAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationsMarkAsReadMutation, { data, loading, error }] = useNotificationsMarkAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotificationsMarkAsReadMutation(
  baseOptions?: Apollo.MutationHookOptions<NotificationsMarkAsReadMutationResult, NotificationsMarkAsReadMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<NotificationsMarkAsReadMutationResult, NotificationsMarkAsReadMutationVariables>(
    NotificationsMarkAsReadDocument,
    options
  );
}
export type NotificationsMarkAsReadMutationHookResult = ReturnType<typeof useNotificationsMarkAsReadMutation>;
